import { makeStyles } from '@material-ui/core';
import { StyledSelectOption } from 'component/StandardDropDownCheckBox';
import { StandardTextField } from 'component/StandardTextField';
import themes from 'constants/themes';
import React, { useState } from 'react';
import {
    changeMaxPrice,
    changeMinPrice,
    // checkColorFilter,
    // checkItemFilter,
    // EColorFilter,
    // EItemFilter,
    checkGenderFilter,
    IFilterItem,
} from 'redux/filter/filterSlice';
import { RootState, useAppDispatch, useAppSelector } from 'redux/store';

const FilterWidget = ({ setTriggerUpdateSearch }) => {
    const classes = useStyles();
    const {
        // itemFilterList, colorFilterList,
        genderFilterList,
        currentMinPrice,
        currentMaxPrice,
    } = useAppSelector((state: RootState) => state.filter);
    const [minPrice, setMinPrice] = useState<any>(null);
    const [maxPrice, setMaxPrice] = useState<any>(null);

    const dispatch = useAppDispatch();

    // const handleChangeItemFilter = (item: IFilterItem<EItemFilter>) => {
    //     dispatch(checkItemFilter(item))
    //     setTriggerUpdateSearch(true)
    // }
    //
    // const handleChangeColorFilter = (item: IFilterItem<EColorFilter>) => {
    //     dispatch(checkColorFilter(item))
    //     setTriggerUpdateSearch(true)
    // }

    const handleChangeGenderFilter = (item: IFilterItem<string>) => {
        dispatch(checkGenderFilter(item));
        setTriggerUpdateSearch(true);
    };

    const handleChangeMin = (e) => {
        const value = e.target.value;
        setMinPrice(Number(value));
    };

    const handleChangeMax = (e) => {
        const value = e.target.value;
        setMaxPrice(Number(value));
    };

    return (
        <>
            {/*<div className={classes.filterTitle}> Item </div>*/}
            {/*{*/}
            {/*    itemFilterList.map((item: IFilterItem<EItemFilter>) => (*/}
            {/*        <StyledSelectOption key={item.value} label={item.title} value={item.value} isActive={item.isActive || false} handleChange={() => handleChangeItemFilter(item)} style={{padding: 0}} />*/}
            {/*    ))*/}
            {/*}*/}

            {/*<div className={classes.filterTitle}> Color </div>*/}
            {/*{*/}
            {/*    colorFilterList.map((item: IFilterItem<EColorFilter>) => (*/}
            {/*        <StyledSelectOption key={item.value} label={item.title} value={item.value} isActive={item.isActive || false} handleChange={() => handleChangeColorFilter(item)} style={{padding: 0}} />*/}
            {/*    ))*/}
            {/*}*/}

            <div className={classes.filterTitle}> Gender </div>
            {genderFilterList.map((item: IFilterItem<string>) => (
                <StyledSelectOption
                    key={item.value}
                    label={item.title}
                    value={item.value}
                    isActive={item.isActive || false}
                    handleChange={() => handleChangeGenderFilter(item)}
                    style={{ padding: 0 }}
                />
            ))}

            <div className={classes.filterList}>
                <div className={classes.filterTitle}> Price </div>
                <div className={classes.filterMinMaxWrap}>
                    <div>
                        <StandardTextField
                            type={'number'}
                            defaultValue={currentMinPrice}
                            label="Min"
                            onChange={handleChangeMin}
                            onBlur={() => {
                                dispatch(changeMinPrice(minPrice));
                                setTriggerUpdateSearch(true);
                            }}
                        />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <StandardTextField
                            type={'number'}
                            defaultValue={currentMaxPrice}
                            label="Max"
                            onChange={handleChangeMax}
                            onBlur={() => {
                                dispatch(changeMaxPrice(maxPrice));
                                setTriggerUpdateSearch(true);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default FilterWidget;

const useStyles = makeStyles(() => ({
    filterList: {},
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    filterMinMaxWrap: {
        display: 'flex',
        alignItems: 'center',
    },
}));
